import React from "react";
import "./index.scss";
import { Tooltip } from "antd";

const Button = ({ children, className = "button", onClick, disabled, id, style ,tooltipTitle="You don't have permission."}) => {
  const handleClick = (e) => {
    if (onClick && !disabled) {
      onClick(e);
    }
  };

  return (
    <Tooltip arrow title={disabled ? tooltipTitle : ""}>
    <button
      style={style}
      id={id}
      className={`${className} ${disabled ? 'disabled' : ''}`} 
      onClick={handleClick}
      disabled={disabled}
    >
      {children}
    </button>
    </Tooltip>
   
  );
};

export default Button;
